import { render, staticRenderFns } from "./STT.vue?vue&type=template&id=ce3ff946&scoped=true"
import script from "./STT.vue?vue&type=script&lang=js"
export * from "./STT.vue?vue&type=script&lang=js"
import style0 from "./STT.vue?vue&type=style&index=0&id=ce3ff946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3ff946",
  null
  
)

export default component.exports